export default "__VITE_ASSET__CGGs3JM5__"